import React, { useState } from 'react';
import { Box, Button, ButtonBase, IconButton, Popover, Tooltip, Typography } from '@mui/material';
import {
  ArrowDropDown as ArrowDropDownIcon,
  CalendarMonth as CalendarIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';
import { MONTH_NAMES } from './format';

/** Selettore mese: frecce mese precedente/successivo e pannello mesi dell'anno. month 1-12. */
export default function MonthPicker({ year, month, onChange }) {
  const [anchor, setAnchor] = useState(null);
  const [panelYear, setPanelYear] = useState(year);
  const shift = (delta) => {
    const d = new Date(year, month - 1 + delta, 1);
    onChange(d.getFullYear(), d.getMonth() + 1);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Tooltip title="Previous month">
        <IconButton size="small" onClick={() => shift(-1)}>
          <ChevronLeftIcon />
        </IconButton>
      </Tooltip>
      <ButtonBase
        onClick={(e) => {
          setPanelYear(year);
          setAnchor(e.currentTarget);
        }}
        sx={{
          gap: 1,
          px: 1.5,
          height: 40,
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
          '&:hover': { bgcolor: 'var(--rt-grey-50)', borderColor: 'text.secondary' },
        }}
      >
        <CalendarIcon fontSize="small" sx={{ color: 'text.secondary' }} />
        <Typography sx={{ fontWeight: 700, minWidth: 120 }}>
          {MONTH_NAMES[month - 1]} {year}
        </Typography>
        <ArrowDropDownIcon sx={{ color: 'text.secondary', ml: -0.5 }} />
      </ButtonBase>
      <Tooltip title="Next month">
        <IconButton size="small" onClick={() => shift(1)}>
          <ChevronRightIcon />
        </IconButton>
      </Tooltip>

      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Box sx={{ p: 1.5, width: 260 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
            <IconButton size="small" onClick={() => setPanelYear((y) => y - 1)}>
              <ChevronLeftIcon fontSize="small" />
            </IconButton>
            <Typography sx={{ fontWeight: 700 }}>{panelYear}</Typography>
            <IconButton size="small" onClick={() => setPanelYear((y) => y + 1)}>
              <ChevronRightIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 0.5 }}>
            {MONTH_NAMES.map((name, idx) => {
              const selected = panelYear === year && idx + 1 === month;
              return (
                <Button
                  key={name}
                  size="small"
                  variant={selected ? 'contained' : 'text'}
                  color={selected ? 'success' : 'inherit'}
                  onClick={() => {
                    onChange(panelYear, idx + 1);
                    setAnchor(null);
                  }}
                  sx={{ textTransform: 'none' }}
                >
                  {name.slice(0, 3)}
                </Button>
              );
            })}
          </Box>
        </Box>
      </Popover>
    </Box>
  );
}
